module.exports = __webpack_public_path__ + "static/adCreation-599a060e59e4faea49f726c51b97e0cb.png";